import { Timestamp } from 'firebase/firestore';

export type UserRole = 'player' | 'admin' | 'superadmin';

export interface UserProfile {
  uid: string;
  name: string;
  email: string;
  phone?: string;
  alias?: string; // Optional field for display on waitlist (max 12 characters)
  role: UserRole;
  roomId?: string; // Only set for admins
  pushTokens?: string[]; // Array of Expo push tokens for mobile notifications
  created_at: Timestamp;
  last_active?: Timestamp;
  signup_source?: 'web' | 'mobile' | 'AI-prompt';
  deletion_requested?: boolean;
  deletion_requested_at?: Timestamp;
}

export interface CreateUserProfileData {
  name: string;
  email: string;
  phone?: string | undefined;
  alias?: string | undefined;
  role: UserRole;
  roomId?: string | undefined;
  signup_source?: 'web' | 'mobile' | 'AI-prompt' | undefined;
}

export interface UpdateUserProfileData {
  phone?: string | undefined;
  alias?: string | undefined;
  pushTokens?: string[] | undefined;
  last_active?: Timestamp | undefined;
}

export const USER_ROLES: UserRole[] = [
  'player',
  'admin',
  'superadmin'
];
